var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgMovingHollowlands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Moving_BG_-_Buildings",
    "data-name": "Moving BG - Buildings",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16325 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#22141d;}.cls-3{fill:#23151e;}.cls-4{fill:#2e1c27;}.cls-5{fill:#22151d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11792.23 1087 11723.83 1087 11832.98 629.34 11901.39 629.34 11792.23 1087"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11792.23 1524.98 11723.83 1524.98 11349.83 1277 11418.23 1277 11792.23 1524.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "11015.09 1087 10946.68 1087 11723.83 1087 11792.23 1087 11015.09 1087"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "10593.28 1807.79 10524.88 1807.79 11723.83 1524.98 11792.23 1524.98 10593.28 1807.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "10488.88 1035 10420.47 1035 10548.27 900 10616.68 900 10488.88 1035"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12136.7,2126.36h-235.31v-175H10593.28v175H10358L10488.88,1035l127.8-135,398.41,187h777.14l109.16-457.66L12087.3,847Zm-1543.42-318.57L11792.23,1525l-374-248-824.95,343v187.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10357.98 2126.36 10289.57 2126.36 10420.47 1035 10488.88 1035 10357.98 2126.36"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "7842.11 432.4 7773.7 432.4 7837.9 432.4 7906.3 432.4 7842.11 432.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8241.24 170 8172.83 170 7773.7 -73.96 7842.11 -73.96 8241.24 170"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7802.4 703 7733.99 703 7608.07 399 7676.48 399 7802.4 703"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7676.48 399 7608.07 399 7415.44 134 7483.84 134 7676.48 399"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "7462.58 1244.19 7394.18 1244.19 7733.99 703 7802.4 703 7462.58 1244.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "7218.85 1318 7150.45 1318 7394.18 1244.19 7462.58 1244.19 7218.85 1318"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7575.87 2112.24 7507.47 2112.24 7150.45 1318 7218.85 1318 7575.87 2112.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "7089.17 306 7020.76 306 7394.18 -343.22 7462.58 -343.22 7089.17 306"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "7989.39 -871.69 7989.39 -343.22 7906.3 -343.22 8241.24 170 7842.11 -73.96 7842.11 432.4 7906.3 432.4 7906.3 1244.19 7793.01 1355.18 7793.01 2112.24 7575.87 2112.24 7218.85 1318 7462.58 1244.19 7802.4 703 7676.48 399 7483.84 134 7089.17 306 7462.58 -343.22 7381.39 -343.22 7381.39 -871.69 7547.55 -871.69 7547.55 -767.2 7823.23 -767.2 7823.23 -871.69 7989.39 -871.69"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9682.24 196 9613.84 196 9496.28 151.08 9564.68 151.08 9682.24 196"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "9159.77 1482 9091.37 1482 9313.14 754 9381.54 754 9159.77 1482"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9381.54 754 9313.14 754 8973.91 477 9042.31 477 9381.54 754"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9042.31 477 8973.91 477 8878.06 87 8946.47 87 9042.31 477"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8749.1 360 8680.7 360 8412.05 151.08 8480.45 151.08 8749.1 360"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8480.45 151.08 8412.05 151.08 8363.01 -227.16 8431.41 -227.16 8480.45 151.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "8379.83 1027.97 8311.43 1027.97 8680.7 360 8749.1 360 8379.83 1027.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8570.56 1188.97 8502.16 1188.97 8311.43 1027.97 8379.83 1027.97 8570.56 1188.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "8376.99 1601 8308.58 1601 8502.16 1188.97 8570.56 1188.97 8376.99 1601"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8404.92 1865.08 8336.52 1865.08 8308.58 1601 8376.99 1601 8404.92 1865.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9945.69,2128.3H8329.39l75.53-263.22L8377,1601l193.57-412-190.73-161L8749.1,360,8480.45,151.08l-49-378.24h515.41L9249-86l7.47-241.14,75.53,100h512L9682.24,196l-117.56-44.92L9497.12,1103l47.9,293,3.79,259,321.35,210.08ZM8946.46,87l-168.2,598,30,520,351.48,277,221.76-728L9042.31,477,8946.46,87"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6663.37 2127.97 6594.96 2127.97 6103.19 1506.97 6171.6 1506.97 6663.37 2127.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5959.23 120.97 5890.82 120.97 6115.44 -105 6183.84 -105 5959.23 120.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5579.59 1506.97 5511.19 1506.97 5940.65 929.97 6009.06 929.97 5579.59 1506.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5657.58 929.97 5589.18 929.97 5389.99 327.97 5458.4 327.97 5657.58 929.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6496.73,1088l402,1040H6663.37L6171.6,1507l-816.31,446.09V2128H5213.93L5020.47,499l446.38-767,492.37,389,224.62-226L6009.06,620Zm-917.14,419,429.47-577H5657.58L5458.4,328l-51.69,421,172.88,758"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5213.94 2127.97 5145.53 2127.97 4952.07 498.97 5020.47 498.97 5213.94 2127.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5020.47 498.97 4952.07 498.97 5398.45 -268 5466.85 -268 5020.47 498.97"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4008.55 1164 3940.15 1164 3719.32 726 3787.73 726 4008.55 1164"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "3671.2 410 3602.8 410 3871.55 -42 3939.96 -42 3671.2 410"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3787.73 726 3719.32 726 3193.09 685 3261.49 685 3787.73 726"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3238.95 1507 3170.54 1507 3940.15 1164 4008.55 1164 3238.95 1507"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3643.01 834 3574.6 834 3065.29 794 3133.7 794 3643.01 834"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3105.51 505 3037.1 505 3602.8 410 3671.2 410 3105.51 505"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2802.93 1101 2734.52 1101 3037.1 505 3105.51 505 2802.93 1101"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "4017.05 -834.01 4017.05 -305.55 3933.98 -305.55 4390.07 -51 4422.96 112 4647.54 328 4516.93 572 4490.62 1006 4324.29 1594 4647.54 2128 2694.86 2128 3238.95 1507 4008.55 1164 3787.73 726 3261.49 685 3643.01 834 3133.7 794 2802.93 1101 3105.51 505 3671.2 410 3939.96 -42 3490.25 -305.55 3409.05 -305.55 3409.05 -834.01 3575.22 -834.01 3575.22 -729.53 3850.89 -729.53 3850.89 -834.01 4017.05 -834.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2694.86 2128 2626.45 2128 3170.54 1507 3238.95 1507 2694.86 2128"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13667.48 397 13599.08 397 13563.45 -272 13631.86 -272 13667.48 397"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13332.02 545 13263.61 545 13599.08 397 13667.48 397 13332.02 545"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13631.85 2126.11 13563.45 2126.11 13118.9 1652 13187.3 1652 13631.85 2126.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13187.3 1652 13118.9 1652 13057.81 1227 13126.22 1227 13187.3 1652"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12937.34 901 12868.94 901 12712.01 685 12780.41 685 12937.34 901"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12712.01,
    y: 523,
    width: 68.4,
    height: 162
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "12780.41 523 12712.01 523 12830.41 446 12898.81 446 12780.41 523"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "12755.04 1255 12686.63 1255 12868.94 901 12937.34 901 12755.04 1255"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "13631.86 -272 13817.75 76.66 13882.67 518 13556.6 595 13370.54 848 13744.53 1531 13867.17 2126.11 13631.85 2126.11 13187.3 1652 13126.22 1227 12767.26 1544 12370.34 2126.11 12755.04 1255 12937.34 901 12780.41 685 12780.41 523 12898.81 446 13332.02 545 13667.48 397 13631.86 -272"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "12370.34 2126.11 12301.94 2126.11 12686.63 1255 12755.04 1255 12370.34 2126.11"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14869.1 2125.99 14800.7 2125.99 14911.88 1538.66 14980.28 1538.66 14869.1 2125.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14980.28 1538.66 14911.88 1538.66 14687.4 1257.94 14755.81 1257.94 14980.28 1538.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14734.08 549.64 14665.68 549.64 14723 232.66 14791.4 232.66 14734.08 549.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14755.81 1257.94 14687.4 1257.94 14419.48 842.66 14487.88 842.66 14755.81 1257.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "14487.88 842.66 14419.48 842.66 14665.68 549.64 14734.08 549.64 14487.88 842.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "14720.91 793.64 14856.23 1262.64 15086.24 1368.94 15086.24 2125.99 14869.1 2125.99 14980.28 1538.66 14755.81 1257.94 14487.88 842.66 14734.08 549.64 14791.4 232.66 14382.39 319.75 15199.53 -329.45 14911.68 88.66 15031.02 196.66 14886.31 355.66 14720.91 793.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "14382.39 319.75 14313.99 319.75 15131.13 -329.45 15199.53 -329.45 14382.39 319.75"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2163.41 1535 2095.01 1535 1842.16 1276.95 1910.57 1276.95 2163.41 1535"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1726.46 812 1658.06 812 1466.36 672 1534.76 672 1726.46 812"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1505.63 1165 1437.23 1165 1658.06 812 1726.46 812 1505.63 1165"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1534.76 672 1466.36 672 1364.87 609 1433.27 609 1534.76 672"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1433.27 609 1364.87 609 1309.42 374 1377.83 374 1433.27 609"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1137.27 1250 1068.87 1250 1437.23 1165 1505.63 1165 1137.27 1250"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1081.83 1539 1013.42 1539 1068.87 1250 1137.27 1250 1081.83 1539"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1741.2 2145 1672.8 2145 1013.42 1539 1081.83 1539 1741.2 2145"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1377.83 374 1309.42 374 643.19 107 711.59 107 1377.83 374"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "711.59 107 2468.81 338.76 2249.87 532 1943.07 568.66 2163.41 1535 1910.57 1276.95 1892.78 1589 1741.2 2145 1081.83 1539 1137.27 1250 1505.63 1165 1726.46 812 1534.76 672 1433.27 609 1377.83 374 711.59 107"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMovingHollowlands);
export default __webpack_public_path__ + "static/media/bg-moving-hollowlands.04989b9e2972b3ef36d83ad21e69bc49.svg";
export { ForwardRef as ReactComponent };